import { useCallback, useEffect } from 'react';
import { TextCheckbox } from 'taboola-ultimate-ui';
import { FormField } from 'taboola-ultimate-ui';
import { SUPPLY_TARGETING_TYPES } from 'modules/campaigns/modules/common-campaign-form/components/SupplyTargeting/const';
import { useAPISupplyTargetingRestrictions } from 'modules/campaigns/modules/common-campaign-form/components/SupplyTargeting/hooks/useAPISupplyTargetingRestrictions';
import { useSupplyTargetingFormField } from 'modules/campaigns/modules/common-campaign-form/components/SupplyTargeting/hooks/useSupplyTargetingFormField';
import { getDefaultSupplyTargeting } from 'modules/campaigns/modules/common-campaign-form/config/InitialValues';
import { CREATIVE_TYPES } from 'modules/campaigns/modules/creative-display/config/displayTypes';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './yahooMomentsCheckbox.module.scss';

export const YahooMomentsCheckbox = () => {
    const { value: yahooMoments, onChange: setYahooMoments } = useFormFieldValue({
        field: 'campaignTargeting.yahooMoments',
    });
    const { value: type } = useFormFieldValue({
        field: 'eligibilityType',
    });
    const isTaboolaDefaultValue = useConfigMatch({
        [FEATURE_FLAGS.SUPPLY_TARGETING_USE_TABOOLA_VALUE_AS_DEFAULT]: 'true',
    });
    const { value: supplyTargeting, onChange: setSupplyTargeting } = useSupplyTargetingFormField();
    const { supplyTargetingResource, isSupplyPermitted } = useAPISupplyTargetingRestrictions();
    const defaultSupplyTargeting = getDefaultSupplyTargeting({
        isSupplyPermitted,
        isTaboolaDefaultValue,
        isPermitted: true,
    });
    const onSelect = useCallback(() => {
        setYahooMoments(true);
        setSupplyTargeting(SUPPLY_TARGETING_TYPES.YAHOO_MOMENTS);
    }, [setYahooMoments, setSupplyTargeting]);
    const onUnSelect = useCallback(() => {
        setYahooMoments(false);
        setSupplyTargeting(defaultSupplyTargeting);
    }, [setYahooMoments, setSupplyTargeting, defaultSupplyTargeting]);
    const isVisible = supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.YAHOO_MOMENTS]?.isVisible;
    const isDisplay = type === CREATIVE_TYPES.DISPLAY;
    const isSupplyTargetingYahooMoments = supplyTargeting === SUPPLY_TARGETING_TYPES.YAHOO_MOMENTS;

    useEffect(() => {
        if (!isDisplay && isSupplyTargetingYahooMoments) {
            onUnSelect();
        }
        if (!isSupplyTargetingYahooMoments) {
            setYahooMoments(false);
        }
    }, [isDisplay, onUnSelect, isSupplyTargetingYahooMoments, setYahooMoments]);

    if (!isSupplyPermitted || !isVisible || !isDisplay) {
        return null;
    }

    return (
        <FormField containerClass={styles['container']}>
            <TextCheckbox
                value={yahooMoments && isDisplay}
                title={
                    <FormattedMessage
                        id="campaign.creator.yahoo.moments.checkbox"
                        defaultMessage="Run this line exclusively on Vertical O&O placements"
                    />
                }
                onSelectCheckbox={onSelect}
                onUnselectCheckbox={onUnSelect}
                selectedValues={[true]}
                independent
            />
        </FormField>
    );
};
